import { defineStore } from 'pinia';
import Filter from '@/models/Card/Filter/filter';

export const useCardFilterStore = defineStore('cardFilter', {
  state: () => ({
    filter: new Filter(),
  }),
  actions: {
    reset() {
      this.filter = new Filter();
    },
    invertSortDirection() {
      this.filter.sort.direction = this.filter.sort.direction === 'ASC' ? 'DESC' : 'ASC';
    },
  },
});
